import { useContext, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'

import { DrawerBodyWrapper, DrawerFooterWrapper, EmptyState } from '@base'
import { SearchInput } from '@baseV2'
import { strings } from '@constants'
import { DrawerHeaderSlotContext } from '@global/Drawer/context'
import GSTAddressCardV2 from './GSTAddressCardV2'
import { toggleDrawer } from '@data/state/action/root'
import { Spacings } from '@styles'

const AddressListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
`

const searchableText = (item) => {
	const address = item?.address ?? {}
	return [item?.gst, address.address_id, address.complete_address, address.city, address.state, address.pincode]
		.filter(Boolean)
		.join(' ')
		.toLowerCase()
}

const SelectGst = ({ updateCallback, addresses = [], selectedAddressId, showSearch = true }) => {
	const dispatch = useDispatch()
	const headerSlot = useContext(DrawerHeaderSlotContext)
	const [query, setQuery] = useState('')

	const filteredAddresses = useMemo(() => {
		const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean)
		if (!tokens.length) return addresses
		return addresses.filter((item) => {
			const haystack = searchableText(item)
			return tokens.every((token) => haystack.includes(token))
		})
	}, [addresses, query])

	const selectAddress = (address) => () => {
		updateCallback(address)
		dispatch(toggleDrawer(false))
	}

	return (
		<>
			{showSearch &&
				headerSlot &&
				createPortal(
					<SearchInput
						value={query}
						onChange={(e) => setQuery(e?.target?.value ?? '')}
						onClear={() => setQuery('')}
						placeholder={strings('search')}
						maxWidth='100%'
					/>,
					headerSlot
				)}
			<DrawerBodyWrapper>
				{filteredAddresses?.length ? (
					<AddressListWrapper>
						{filteredAddresses.map((item, index) => (
							<div onClick={selectAddress(item)} key={item?.address?.address_id ?? index}>
								<GSTAddressCardV2
									gst={item?.gst}
									address={item?.address}
									selected={!!selectedAddressId && item?.address?.address_id === selectedAddressId}
								/>
							</div>
						))}
					</AddressListWrapper>
				) : (
					<EmptyState noAction text={strings('no_address_found')} />
				)}
			</DrawerBodyWrapper>
			<DrawerFooterWrapper></DrawerFooterWrapper>
		</>
	)
}

export default SelectGst
